module.exports = __webpack_public_path__ + "static/media/galerija_2021 (13).f00bac15.jpg";